import React, { useState, useEffect } from 'react'
import Header from 'components/template/Header'
import SidePanel from 'components/template/SidePanel'
import SideNavToggle from 'components/template/SideNavToggle'
import UserDropdown from 'components/template/UserDropdown'
import LanguageSelector from 'components/template/LanguageSelector'
import MobileNav from 'components/template/MobileNav'
import SideNav from 'components/template/SideNav'
import CookieConsentBanner from 'components/template/CookieConsentBanner'
import View from 'views'

const HeaderActionsStart = () => {
    return (
        <>
            <MobileNav />
            <SideNavToggle />
        </>
    )
}

const HeaderActionsEnd = () => {
    return (
        <>
            <LanguageSelector />
            <SidePanel />
            <UserDropdown hoverable={false} />
        </>
    )
}

const ModernLayout = (props) => {
    const [showCookieBanner, setShowCookieBanner] = useState(true);

    useEffect(() => {
        const hasConsented = document.cookie.split('; ').find(row => row.startsWith('cookieConsent='));
        if (hasConsented) {
            setShowCookieBanner(false);
        }
    }, []);

    const handleAcceptCookies = () => {
        setShowCookieBanner(false);
    };

    return (
        <div className="app-layout-modern flex flex-auto flex-col">
            {showCookieBanner && <CookieConsentBanner onAccept={handleAcceptCookies} />}
            <div className="flex flex-auto min-w-0">
                <SideNav />
                <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full bg-white dark:bg-gray-800 border-l border-gray-200 dark:border-gray-700">
                    <Header
                        className="border-b border-gray-200 dark:border-gray-700"
                        headerEnd={<HeaderActionsEnd />}
                        headerStart={<HeaderActionsStart />}
                    />
                    <View {...props} />
                </div>
            </div>
        </div>
    )
}

export default ModernLayout
